import React from 'react';
import './Textarea.scss';

const Textarea = ({
  label,
  onChange,
  placeholder,
  required,
  value,
  maxLength,
  disabled,
}: any) => (
  <>
    <div className="textarea">
      <div className="input__require">
        {label && <label className="textarea__label">{label}</label>}
        {required && <div className="input__required" />}
      </div>
      <textarea
        className="textarea__control"
        onChange={onChange}
        value={value}
        required={required}
        placeholder={placeholder}
        maxLength={maxLength ? maxLength : null}
        disabled={disabled ? disabled : false}
        rows={5}
      />
      <div className="textarea__underline" />
    </div>
    {maxLength ? (
      <div
        style={{ display: 'flex', justifyContent: 'flex-end', marginTop: -15 }}
      >
        {value.length + '/' + maxLength}
      </div>
    ) : null}
  </>
);

Textarea.defaultProps = {
  value: '',
};

export default Textarea;
